module.exports = __webpack_public_path__ + "img/img2.59b35ad9.svg";